import React from 'react';
import useProtectedApplication from 'Hooks/useProtectedApplication';
import LoadingRedesign from 'Redesign_Funnel/components/Loading';

export const Application: React.FC = ({ children }) => {
  const {
    isLoading,
  } = useProtectedApplication();

  return isLoading ? <LoadingRedesign /> : <>{children}</>;
};
